import { connect } from 'react-redux';
import Event from '../components/event';
import { fetchResultScope, removeResultScope } from '../actions/event_index';
import {
  selectIsManagerSite,
  selectShowMobileExpandToggle,
  selectHasExpandableScorecards,
  selectCutLineButton,
  selectPointsAndPurseButton,
  selectParentEvent,
  selectStateFlagUrls,
  makeShallowStableSelector,
  selectCurrentRoundLabel,
} from '../selectors';
import { EMPTY_ARRAY } from '../utils/empty';

// Factory form: the manager-site button selectors build a fresh props object
// on every call, so each event keeps its own last result and reuses it while
// the fields are unchanged.
const makeMapStateToProps = () => {
  const selectStableCutLineButton = makeShallowStableSelector(selectCutLineButton);
  const selectStablePointsAndPurseButton = makeShallowStableSelector(selectPointsAndPurseButton);

  return (state, ownProps) => {
    const eventState = state.event[ownProps.id] || {};
    const isOpen = !!state.event[ownProps.id];

    return {
      data: eventState.data || null,
      loading: eventState.loading || false,
      error: eventState.error || null,
      isOpen,
      showExpandAll: isOpen && selectHasExpandableScorecards(state, ownProps.id),
      holeByHoleView: state.leaderboardV2.holeByHoleView,
      displayedFlags: state.leaderboardV2.displayedFlags,
      stateFlagUrls: selectStateFlagUrls(state),
      showExpandToggle: selectShowMobileExpandToggle(state, ownProps.id, ownProps.narrowMobile),
      isManagerSite: selectIsManagerSite(state),
      cutLineButton: ownProps.isSpec ? null : selectStableCutLineButton(state, ownProps.id),
      // Per event, never on the spec row (the HTML leaderboard shows it per
      // event too); resolved via the parent so a snapshot id finds its event.
      infoTooltip: ownProps.isSpec ? EMPTY_ARRAY : (selectParentEvent(state, ownProps.id)?.infoTooltip ?? EMPTY_ARRAY),
      pointsAndPurseButton: selectStablePointsAndPurseButton(state, ownProps.id, {
        isSpec: ownProps.isSpec,
        isGroup: ownProps.isGroup,
      }),
      currentRoundLabel: ownProps.isSpec ? null : selectCurrentRoundLabel(state),
    };
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchResultScope: () => dispatch(fetchResultScope(ownProps.id, { viewMode: ownProps.viewMode })),
  removeResultScope: () => dispatch(removeResultScope(ownProps.id)),
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Event);
